import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMConst from 'lib/SMConst';
import SMMessageConnector from 'connectors/SMMessageConnector';
import update from 'react-addons-update';
import SMAppHelper from 'components/helpers/SMAppHelper';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMMessageInputView from './SMMessageInputView';
import SMMessageNoticeView from './SMMessageNoticeView';
import SMMessageSenderView from './SMMessageSenderView';
import SMMessageBaloonView   from './SMMessageBaloonView';
import SMMessageItineraryView from './SMMessageItineraryView';
import SMMessageFooterView from './SMMessageFooterView';
import SMReservationResource from 'resources/SMReservationResource';
import SMMessageTimelineView from './SMMessageTimelineView';
import SMMessageTimestampView from './SMMessageTimestampView';
import SMUReservationMessageCloseView from 'components/dashboard/users/reservations/SMUReservationMessageCloseView';
import Spinner from 'components/shared/SMMaterialSpinner';

class SMMessageView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.currentPage = this.props.page;
    this.canRequest = true;
    this.shouldLoadData = false;
    this.state = {
      display: this.props.display,
      listItems: [],
    };
  }

  componentDidMount() {
    if (this.props.isCurrentView && this.props.display == SMConst.Display.Visible) {
      this.requestResource();
    }
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    this.connector = new SMMessageConnector();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
    this.connector.unsubscribe();
  }

  sizeToFit() {
    if (this.state.display == SMConst.Display.Visible) {
      let $mainTable = $("#js-split_view-main"),
          $mainTableFooter = $(ReactDOM.findDOMNode(this.refs.mainTableFooter));
      $mainTableFooter.outerWidth($mainTable.outerWidth());

      if (!SMAppHelper.isMobile() && this.refs.scroller) {
        let $scroller = $(this.refs.scroller);
        let $footer = $('#js-dashboard-footer');
        $scroller.outerHeight($(window).outerHeight() - $scroller.offset().top - $footer.outerHeight());
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    let newState = this.state;
    if (this.props.reservation !== nextProps.reservation){
      if (nextProps.reservation == null) {
        newState.display = SMConst.Display.Init;
      }
    }
    if (this.props.display !== nextProps.display){
      newState.display = nextProps.display;
    }
    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.reservation !== prevProps.reservation &&
        this.props.reservation != null) {
      this.shouldLoadData = true;
      $(this.refs.scroller).scrollTop(0);
    }

    if (this.props.isCurrentView && this.shouldLoadData) {
      this.shouldLoadData = false;
      this.currentPage = 1;
      this.messageContent = "";
      this.requestResource();

      this.connector.subscribe(this.props.reservation, "new-message", (message)=>{
        // add comment into page
        if (this.props.isOwner) {
          if (message.from_type == "Owner") return;
        } else {
          if (message.from_type == "User") return;
        }
        this.setState({
          listItems: update(this.state.listItems, {$unshift: [message]})
        });
      });
    }
    this.sizeToFit();
  }

  messageContentDidChange(messageContent){
    this.messageContent = messageContent;
  }

  messageCloseDidSelect(e) {
    e.preventDefault();
    this.showDialog(
      <SMUReservationMessageCloseView reservation={this.props.reservation} delegate={this} />
    );
  }

  messageDidClose(data, xhr) {
    this.hideDialog();
    if(this.props.delegate && typeof this.props.delegate.messageDidClose === 'function'){
      this.props.delegate.messageDidClose(data, this.props.rowIndex, xhr);
    }
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000001"));
  }

  messageDidCloseFail(error, xhr) {
    $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
  }

  requestResource(isAppend, callback){
    if (this.state.display == SMConst.Display.Loading) return;
    this.setState({display: SMConst.Display.Loading});
    let queries = {};
    if (this.currentPage != 1) queries["page"] = this.currentPage;
    SMReservationResource.getMessages(this.props.reservation.uid, queries, (responses, error)=>{
      if(error) return;
      this.currentPage++;
      this.setState({
        listItems: responses,
        display: SMConst.Display.Visible
      });
      if(this.props.delegate && typeof this.props.delegate.messageDidReadRowAtIndex === 'function'){
        this.props.delegate.messageDidReadRowAtIndex(this.props.rowIndex);
      }
    });
  }

  messageDidCreate(message){
    this.setState({
      listItems: update(this.state.listItems, {$unshift: [message]})
    });
    $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000004"));
  }

  messageDidFailToCreate(error){
    $("#js-split_view-main").showFailMessage(I18n.t("dashboard.notice_000007"));
  }

  chanegeInquiryToReservation(reservation){
    location.href= Routes.space_room_reservations_path(reservation.room.space.username, reservation.room.uid, {inquiry_id: reservation.uid});
  }

  /* Render */

  renderInit (){
    return (
      <p className="dashboard-maincol__message">{I18n.t("dashboard.text_000015")}</p>
    );
  }

  renderDefault (){

    let reservation = this.props.reservation;
    let messages = [];
    let currentTimelineStatus = null;
    let isOwner = this.props.isOwner;

    for (let i = 0; i < this.state.listItems.length; i++) {
      let message = this.state.listItems[i];
      let key = message.id;
      switch (message.timeline_type) {
        case SMConst.MessageType.Message:
          if (this.props.isOwner) {
            if (message.from_type == "Owner") {
              messages.push(<SMMessageSenderView key={key} message={message} reservation={reservation} />);
            } else {
              messages.push(<SMMessageBaloonView key={key} message={message} reservation={reservation} />);
            }
          } else {
            if (message.from_type == "Owner") {
              messages.push(<SMMessageBaloonView key={key} message={message} reservation={reservation} />);
            } else {
              messages.push(<SMMessageSenderView key={key} message={message} reservation={reservation} />);
            }
          }
          break;
        case SMConst.MessageType.Timeline:
          if (!isOwner) {
            let timelineData = JSON.parse(message.timeline_data);
            if (timelineData.reservation.status == SMConst.ReservationStatus.Paid &&
              currentTimelineStatus != timelineData.reservation.status) {
                messages.push(
                  <SMMessageItineraryView key={key + '-itinerary'} message={message} reservation={reservation} />
                );
            }
            currentTimelineStatus = timelineData.reservation.status;
          }
          messages.push(<SMMessageTimelineView key={key} message={message} />);
          break;
        case SMConst.MessageType.ServiceMessage:
          messages.push(<SMMessageBaloonView key={key} message={message} reservation={reservation} />);
          break;
        default:
          continue;
      }
      messages.push(<SMMessageTimestampView key={key + "-" + message.created_at} message={message} />);
    }


    let dashboardCloseMessage = null;
    if (!this.props.isOwner && reservation.method == SMConst.ReservationMethod.Inquiry) {
      let messageWillCloseAt = null;
      let className = "pt9 pb9 w200 fr";
      let disabled = false;
      let buttonValue = I18n.t("dashboard.label_000712");
      if (reservation.message_closed_at) {
        messageWillCloseAt = I18n.t("dashboard.label_000725");
        if (reservation.need_preview && !reservation.message_closed_reason_type &&
            reservation.message_disable_reason_type == SMConst.MessageDisableReasonType.Expired) {
          className += " button-green";
          buttonValue = I18n.t("dashboard.label_000729");
        } else {
          className += " button-disabled";
          disabled = true;
        }
      } else {
        messageWillCloseAt = reservation.message_will_close_at;
        className += " button-blue";
      }

      dashboardCloseMessage = (
        <div className="dashboard-message__close-btn clearfix">
          <p className="dashboard-message__period">{I18n.t("dashboard.label_000711")}<span className="dashboard-message__period-num">{messageWillCloseAt}</span></p>
          <input onClick={this.messageCloseDidSelect.bind(this)} className={className} type="submit" value={buttonValue} disabled={disabled} />
          <input onClick={this.chanegeInquiryToReservation.bind(this, reservation)} className="button-blue pt9 pb9 w200 mr10 fr" type="button" value={I18n.t("dashboard.label_000148")} />
        </div>
      );
    }

    return (
      <div>
        {dashboardCloseMessage}
        <SMMessageInputView delegate={this} isOwner={isOwner} reservation={reservation} messageContent={this.messageContent} />
        <SMMessageNoticeView isOwner={isOwner} reservation={reservation} />
        <h2 className="dashboard-title mb20">過去のメッセージ</h2>
        <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
          {messages}
        </CSSTransitionGroup>
        <SMMessageFooterView delegate={this} ref="mainTableFooter" reservation={reservation} isOwner={isOwner} />
      </div>
    );
  }
  
  renderLoading() {
    return (
      <div className="js-empty"><Spinner /></div>
    );
  }

  render() {
    if (!this.props.isCurrentView) return null;
    return (
      <div className="reserve-maincol__right-inner js-scroller" ref="scroller">
        {(()=>{
          switch (this.state.display) {
            case SMConst.Display.Hidden: return null;
            case SMConst.Display.Init: return this.renderInit();
            case SMConst.Display.Loading: return this.renderLoading();
            default: return this.renderDefault();
          }
        })()}
      </div>
    );
  }
}
SMMessageView.propTypes = {
  isOwner: PropTypes.bool.isRequired,
  isCurrentView: PropTypes.bool,
  reservation: PropTypes.object,
  rowIndex: PropTypes.number.isRequired,
};
SMMessageView.defaultProps = {
  display: SMConst.Display.Visible,
  page: 1,
  perPage: 20
};
export default SMMessageView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMMessageView.jsx